import { Tooltip } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';
import PersonIcon from '@mui/icons-material/Person';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import ApartmentIcon from '@mui/icons-material/Apartment';
import { dateTimeString, truncateString } from 'shared/utils';
import Priority from './Priority';

function ticketAssociationIcon(association) {
  if (association?.tenant_id !== 0) {
    return (
      <Tooltip title={`${association?.tenant?.first_name} ${association?.tenant?.last_name}`}>
        <Link to={`/tenant/view/${association?.tenant_id}`}><PersonIcon /></Link>
      </Tooltip>
    );
  }
  if (association?.unit_id !== 0) {
    return !association.unit ? (
      <Tooltip title={association.building.name}>
        <MeetingRoomIcon />
      </Tooltip>
    )
      : (
        <Tooltip title={`${association.building.name} , Unit ${association.unit.name}`}>
          <Link to={`/building/view/${association.building_id}/units/${association.unit_id}`}>
            <MeetingRoomIcon />
          </Link>
        </Tooltip>
      );
  }
  if (association?.building_id !== 0) {
    return (
      <Tooltip title={`${association.building.name}`}>
        <Link to={`/building/view/${association.building_id}`}><ApartmentIcon /></Link>
      </Tooltip>
    );
  }
  return '';
}

const ticketAssociationColumn = {
  name: '',
  jsonKey: 'association',
  columnStyling: { paddingLeft: '.3rem', paddingRight: '0' },
  formatter: (row) => ticketAssociationIcon(row.ticket_association),
};

const ticketPriorityColumn = {
  name: '',
  jsonKey: 'priority',
  columnStyling: { width: '10px', padding: 0, margin: 0 },
  formatter: (row) => <Priority priority={row.priority} />,
};

const sharedTicketColumns = [

  {
    name: 'Ticket #',
    orderBy: 'id',
    formatter: (row) => <Link to={`/ticket/view/${row.id}`}>{row.id}</Link>,
  },
  {
    name: 'Title',
    jsonKey: 'title',
    formatter: (row) => <Link to={`/ticket/view/${row.id}`}>{truncateString(row.title, 56)}</Link>,
  },
  {
    name: 'Status',
    jsonKey: 'status',
    orderBy: 'status',
  },
  {
    name: 'Assigned To',
    formatter: (row) => (row.ticket_assignment && row.ticket_assignment.assignee_username),
  },
  {
    name: 'Created At',
    orderBy: 'created_at',
    formatter: (row) => dateTimeString(row.created_at),
  },
  {
    name: 'Last Entry Updated At',
    orderBy: 'last_entry_updated_at',
    formatter: (row) => dateTimeString(row.last_entry_updated_at),
  },
];

export const ticketColumns = [ticketPriorityColumn, ...sharedTicketColumns];

export const ticketIconColumns = [
  ticketPriorityColumn,
  ticketAssociationColumn,
  ...sharedTicketColumns,
];
